<template>
  <span :class="classes">
    <font-awesome-icon
      v-if="icon"
      :icon="icon"
      class="cordel-tag-icon"
    />

    <slot />
  </span>
</template>

<script>
  const SIZES = ['medium', 'small'];
  const COLORS = [
    'default',
    'danger',
    'external',
    'success',
    'warning',
    'waiting',
    'bright',

    'status-01',
    'status-02',
    'status-03',
    'status-04',
    'status-05',

    'alert-danger',
  ];

  export default {
    name: 'CordelContextTag',
    props: {
      color: {
        type: String,
        default: COLORS[0],
        validator(value) {
          return COLORS.includes(value);
        },
      },
      size: {
        type: String,
        default: SIZES[0],
        validator(value) {
          return SIZES.includes(value);
        },
      },
      icon: {
        type: [String, Array],
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      classes() {
        const classes = [
          'cordel-tag',
          `color--${this.color}`,
          `size--${this.size}`,
        ];

        if (this.disabled) {
          classes.push('state--disabled');
        }

        return classes;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .cordel-tag {
    border-radius: var(--cordel-border-radius-pill);
    color: var(--cordel-color-constant-dark);
    display: inline-block;
    font-size: var(--cordel-font-size-m);
    font-weight: var(--cordel-font-weight-regular);
    padding: 0 var(--cordel-spacing-micro);
    line-height: var(--cordel-line-height-m);
    min-width: calc(var(--cordel-font-size-m) * var(--cordel-line-height-m));
    text-align: center;
    transition: color .1s, background-color .1s;

    & + & {
      margin-left: var(--cordel-spacing-micro);
    }

    @media all and (max-width: $cordel-breakpoint-mobile) {
      font-size: var(--cordel-font-size-s);
    }
  }

  .size--small {
    font-size: var(--cordel-font-size-xs);
    padding: var(--cordel-spacing-xmini);
  }

  .color--default {
    background-color: var(--cordel-color-tag-default);
    color: var(--cordel-color-constant-light);
  }

  .color--external {
    background-color: var(--cordel-color-tag-external);
  }

  .color--warning {
    background-color: var(--cordel-color-tag-warning);
  }

  .color--waiting {
    background-color: var(--cordel-color-status-01-light);
  }

  .color--success {
    background-color: var(--cordel-color-tag-success);
  }

  .color--danger {
    background-color: var(--cordel-color-tag-danger);
  }

  .color--bright {
    background-color: var(--cordel-color-tag-bright);
  }

  .color--status-01 {
    background-color: var(--cordel-color-status-01-light);
  }

  .color--status-02 {
    background-color: var(--cordel-color-status-02-light);
  }

  .color--status-03 {
    background-color: var(--cordel-color-status-03-light);
  }

  .color--status-04 {
    background-color: var(--cordel-color-status-04-light);
  }

  .color--alert-danger {
    background-color: var(--cordel-color-alert-danger);
    color: var(--cordel-color-constant-light);
  }

  .state--disabled {
    background-color: var(--cordel-color-neutral-light);
    color: var(--cordel-color-neutral-primary);
  }
</style>
